import http from '../http'

export default {
    all(usuario) {
        return http.get(`usuarios/${usuario}/ihm/prospectos`)
    },

    update(usuario, prospecto, payload) {
        return http.put(`/usuarios/${usuario}/ihm/prospectos/${prospecto}`, payload)
    },
}